var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2452 3.02438L13.4385 6.25581C13.1705 7.32956 12.333 8.16852 11.2597 8.43852L9.60785 8.85407C9.22698 8.94989 8.90656 9.20652 8.72987 9.55727C8.351 10.3093 7.38438 10.5361 6.71058 10.031L3.7503 7.81174M14.2452 3.02438C13.5264 2.84514 12.7743 2.75 12 2.75C8.39887 2.75 5.27837 4.80785 3.7503 7.81174M14.2452 3.02438C18.2689 4.02764 21.25 7.66569 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 10.4925 3.11062 9.06923 3.7503 7.81174M11.2307 15.8416L10.5635 14.8409C10.2377 14.3522 10.3027 13.7013 10.7188 13.2867C10.9688 13.0377 11.3136 12.9079 11.6657 12.9304L12.3268 12.9726C12.8037 13.003 13.2639 13.1594 13.6605 13.4259L14.9129 14.2676C15.5362 14.6864 15.7515 15.503 15.4156 16.1746C15.1627 16.6805 14.6457 17 14.0801 17H13.3952C12.5254 17 11.7131 16.5653 11.2307 15.8416Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.75996b3b63d50787ea4f03f81069cd59.svg";
export { ForwardRef as ReactComponent };